import React from 'react'
import RefreshIcon from '@mui/icons-material/Refresh'

import Button from 'components/Form/Button'
import { ListSkeleton } from 'components/Skeleton'
import TableWrapper from 'components/TableWrapper'
import TrainingApprovalsTable from 'components/TrainingApprovalsTable'

import useController from './controller'
import {
  Count,
  HeaderActions,
  Page,
  PageEyebrow,
  PageHeader,
  PageIntro,
  PageSubtitle,
  PageTitle,
  State,
  StateText,
  StateTitle,
  StatusTab,
  StatusTabs,
} from './styled'

export default function TrainingApprovals() {
  const {
    summary,
    authorized,
    loading,
    loaded,
    error,
    search,
    status,
    retry,
    onSearchChange,
    onPageChange,
    onStatusChange,
    onReview,
  } = useController()

  return (
    <Page>
      {!authorized ? (
        <ListSkeleton rows={6} />
      ) : (
        <>
          <PageHeader>
            <PageIntro>
              <PageEyebrow>Training certification</PageEyebrow>
              <PageTitle>Certification Approvals</PageTitle>
              <PageSubtitle>
                Review participant results and decide when a certificate is ready to be issued.
              </PageSubtitle>
            </PageIntro>
            <HeaderActions>
              {!loaded || error ? null : (
                <Count>
                  <strong>{summary?.totalPending || 0}</strong>
                  <span>pending</span>
                </Count>
              )}
              <Button
                color="blue"
                disabled={loading}
                nospace
                outline
                startIcon={<RefreshIcon />}
                width="fit-content"
                onClick={() => retry()}
              >
                Refresh
              </Button>
            </HeaderActions>
          </PageHeader>

          <StatusTabs aria-label="Certification approval status">
            {['pending', 'approved', 'rejected'].map(item => (
              <StatusTab
                key={item}
                active={status === item}
                type="button"
                onClick={() => onStatusChange(item)}
              >
                {item[0].toUpperCase() + item.slice(1)}
              </StatusTab>
            ))}
          </StatusTabs>

          <TableWrapper
            title={`${status[0].toUpperCase() + status.slice(1)} certification requests`}
            searchValue={search}
            searchPlaceholder="Search participant or training"
            onSearchChange={onSearchChange}
          >
            {!loaded || (loading && !summary?.rows?.length) ? (
              <ListSkeleton rows={6} />
            ) : error ? (
              <State>
                <StateTitle>Approvals unavailable</StateTitle>
                <StateText>{error}</StateText>
              </State>
            ) : summary?.rows?.length ? (
              <TrainingApprovalsTable
                rows={summary.rows}
                pagination={summary.pagination}
                onReview={onReview}
                onPageChange={onPageChange}
              />
            ) : (
              <State>
                <StateTitle>{search ? 'No matching approvals' : `No ${status} approvals`}</StateTitle>
                <StateText>
                  {search
                      ? 'Try another participant or training name.'
                    : status === 'pending'
                      ? 'New training requests assigned to you will appear here.'
                      : `No ${status} requests are available.`}
                </StateText>
              </State>
            )}
          </TableWrapper>
        </>
      )}
    </Page>
  )
}
